import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { SeoService } from '../../services/seo.service';
import { SettingsService } from '../../services/settings.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'hcf-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeComponent implements OnInit {
  constructor(
    private _seoService: SeoService,
    private _uiService: UiService,
  ) {}

  ngOnInit() {
    this._seoService.setTitle(SettingsService.values.defaultPageTitle);
  }

  switchAPxEC(sourceElement) {
    if (this._uiService.hasClass('hcf-app.mobile hcf-home .' + sourceElement + '-providers-header', 'selected')) {
      return;
    }
    this.toggleAPxEC();
  }

  toggleAPxEC() {
    const selectorPrefix = 'hcf-app.mobile hcf-home';
    this._uiService.toggleClass(selectorPrefix + ' .ap-providers-header', 'selected');
    this._uiService.toggleClass(selectorPrefix + ' .ec-providers-header', 'selected');
    this._uiService.toggleClass(selectorPrefix + ' .ap-providers-content', 'hidden-content');
    this._uiService.toggleClass(selectorPrefix + ' .ec-providers-content', 'hidden-content');
    this._uiService.scrollToAPvsEC();
  }
}
